import type { AgentSummary } from '../agent-chat-module/types/agent.service.type';

/**
 * Finds the default "Buddy" agent from a list of agents.
 * Prioritizes active (not archived, not disabled) agents:
 * 1. Exact name match for "buddy" (case-insensitive, trimmed)
 * 2. Substring match containing "buddy" (case-insensitive)
 */
export function findBuddyAgent(agents?: AgentSummary[] | null): AgentSummary | null {
  if (!agents || agents.length === 0) {
    return null;
  }

  const activeAgents = agents.filter((agent) => !agent.is_archived && !agent.is_disabled);

  // 1. Exact match (e.g. "Buddy", "buddy", "BUDDY")
  const exactMatch = activeAgents.find(
    (agent) => agent.name?.trim().toLowerCase() === 'buddy'
  );
  if (exactMatch) {
    return exactMatch;
  }

  // 2. Substring match (e.g. "Buddy Agent", "Klax Buddy")
  const substringMatch = activeAgents.find(
    (agent) => agent.name?.trim().toLowerCase().includes('buddy')
  );
  if (substringMatch) {
    return substringMatch;
  }

  return null;
}
